"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreDisplay = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const __1 = require("..");
const scoring_model_1 = require("../../utils/scoring-model");
const safe_strings_1 = require("../../utils/safe-strings");
const base_react_components_1 = require("@navinc/base-react-components");
const MainWrapper = styled_components_1.default.div.withConfig({ displayName: "reports-MainWrapper", componentId: "reports-ftirvj" }) `
  width: 100%;
`;
const Wrapper = styled_components_1.default.div.withConfig({ displayName: "reports-Wrapper", componentId: "reports-3i17nu" }) `
  width: 100%;
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
`;
const fadeId = (0, styled_components_1.keyframes) `
  from { opacity: 0; }

  to { opacity: 1; }
`;
const DescriptionGrid = styled_components_1.default.div.withConfig({ displayName: "reports-DescriptionGrid", componentId: "reports-1q981rn" }) `
  display: flex;
  display: grid;
  grid-template-columns: 8px 1fr;
  grid-gap: 8px;
  justify-content: space-around;
  align-items: center;
  margin-top: 8px;
  animation: ${fadeId} 0.25s linear;
`;
const Bit = styled_components_1.default.div.withConfig({ displayName: "reports-Bit", componentId: "reports-4f71ro" }) `
  margin-right: 8px;
  width: 8px;
  height: 8px;
  background-color: ${({ bgColor, theme }) => theme[bgColor]};
  border-radius: 50%;
`;
const LastUpdate = styled_components_1.default.div.withConfig({ displayName: "reports-LastUpdate", componentId: "reports-15xmqw5" }) `
  text-align: center;
  padding-top: 16px;
`;
const ScoreDisplay = ({ bureau, className, score = 0, reportDate, reportableType = 'Business', riskCategory, min, max, }) => {
    const isScoreGrade = (0, scoring_model_1.isGrade)(score);
    const { minScore, maxGood } = (0, scoring_model_1.getScoreMapFromSlug)({ bureau, reportableType, score });
    const status = (0, scoring_model_1.calcScoreColor)({ identifier: bureau, score, reportableType });
    const scoreValue = isScoreGrade ? (0, scoring_model_1.getGradeScore)({ bureau, reportableType, score: score }) : score;
    const gradeValues = isScoreGrade ? { min: 'F', max: 'A', value: score } : undefined;
    return (react_1.default.createElement(MainWrapper, { className: className },
        react_1.default.createElement(__1.ValueArc, { value: scoreValue, displayValues: gradeValues, status: status, max: isScoreGrade || !max ? maxGood : +max, min: isScoreGrade || !min ? minScore : +min }, (riskCategory || status) && (react_1.default.createElement(Wrapper, null,
            react_1.default.createElement(DescriptionGrid, null,
                react_1.default.createElement(Bit, { bgColor: status }),
                react_1.default.createElement(base_react_components_1.Header, { size: "xs" }, (0, safe_strings_1.capitalize)(riskCategory ? riskCategory.toLowerCase() : status)))))),
        !!reportDate && (react_1.default.createElement(LastUpdate, { "data-testid": `credit-reports:last-update:${bureau}` },
            react_1.default.createElement(__1.LastUpdated, { date: reportDate })))));
};
exports.ScoreDisplay = ScoreDisplay;
exports.default = (0, styled_components_1.default)(exports.ScoreDisplay).withConfig({ componentId: "reports-epwd3d" }) ``;
//# sourceMappingURL=index.js.map